export const UserConstants = {
    LOGIN: 'USERS_LOGIN',
    LOGOUT: 'USERS_LOGOUT',

    LOGIN_ROUTE: 'api/user/login',
    LOGOUT_ROUTE: 'api/user/logout',
    AFTER_LOGIN_ROUTE: 'dashboard'
};
